import type { ILocationRepository, LocationUpdateInput } from '../repositories/ILocationRepository.js';
import type { LocationEntity } from '../entities/LocationEntity.js';

export interface UpdateLocationInput { id: string; data: LocationUpdateInput; }
interface Deps { locationRepository: ILocationRepository; }

export function createUpdateLocationUseCase({ locationRepository }: Deps) {
  return async function updateLocation({ id, data }: UpdateLocationInput): Promise<LocationEntity | null> {
    return locationRepository.update(id, data);
  };
}
